import styles from "./BackButton.module.css"
import { ChevronLeft } from 'lucide-react';

/**
* Props for the BackButton component.
*/ 
interface BackButtonTypes {
    text: string;                   // Button label
    disabled?: boolean;      // Disable the button
    className?: string;      // Optional additional class
    onClick: () => void;      // Click event handler
}
/**
* A back button with a chevron icon and label.
*
* @param props BackButton props
* @param {string} props.text - Button label
* @param {boolean} props.disabled - Whether the button is disabled
* @param {string} props.className - Optional additional class
* @param {() => void} props.onClick - Function to call on click.
* @returns TSX.Element
*/
const BackButton = ({ text, disabled = false, onClick } : BackButtonTypes) => {
    
    return (
        <>
            <button onClick={onClick} className={disabled ? `${styles.BackButton} ${styles.Disabled}` : `${styles.BackButton}`} disabled={disabled? true : false}>
                <ChevronLeft />
                <span>{text}</span>
            </button>
        </>
    )
};

export default BackButton;